import React from 'react';
import { MenuItem } from '@material-ui/core';
import { PrimaryButton, TextField } from '../../components/AtomComponents';
import FileWell from '../../components/AtomComponents/FileWell';
import { ISchemaUploadV3FormProps } from '../SchemaSync/types';

export const TYPE_OPTIONS = [
  { label: 'Schema', value: 'Schema' },
  { label: 'Public', value: 'Public' },
  { label: 'TransactionPerTenant', value: 'TransactionPerTenant' },
];

export const SchemaUploadV3Form = ({
  formState,
  onUploadClick,
}: ISchemaUploadV3FormProps) => {
  const { fileProps, formValues } = formState;
  const { fileState, setFile } = fileProps;
  const { release, setRelease, type, setType, tenantId, setTenantId } = formValues;
  const isButtonDisabled = !fileState || !release || !type || (type === 'TransactionPerTenant' && !tenantId);

  return (
    <div>
      <FileWell
        filesLimit={1}
        acceptedFiles={[
          '.xlsx', '.xls', '.csv', 'application/vnd.ms-excel', 'application/msexcel',
          'application/x-msexcel', 'application/x-ms-excel', 'application/x-excel',
          'application/x-dos_ms_excel', 'application/xls', 'application/x-xls',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/excel',
        ]}
        handleDrop={setFile}
        className="margin-bottom-3 margin-top-3"
      />
      <>
        <TextField
          label="Release"
          size="small"
          value={release}
          onChange={(e) => setRelease(e.target.value.trim())}
          placeholder="Release"
          className="margin-right-1 px-release-input"
        />
        <TextField
          select
          label="Type"
          size="small"
          value={type}
          onChange={(e) => {
            const selectedType = e.target.value;
            setType(selectedType);
            if (selectedType !== 'TransactionPerTenant') setTenantId('');
          }}
          className="margin-right-1 px-type-select"
        >
          {TYPE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {type === 'TransactionPerTenant' && (
          <TextField
            label="Tenant ID"
            size="small"
            value={tenantId}
            onChange={(e) => setTenantId(e.target.value.trim())}
            placeholder="Tenant ID"
            className="margin-right-1"
          />
        )}
        <PrimaryButton onClick={onUploadClick} disabled={isButtonDisabled}>
          Upload Schema
        </PrimaryButton>
      </>
    </div>
  );
};
